var _rect, _rect2, _path, _rect3, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDragVideo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 174,
    height: 44,
    viewBox: "0 0 174 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 173,
    height: 43,
    rx: 5.5,
    fill: "#F0F5F8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 173,
    height: 43,
    rx: 5.5,
    stroke: "#203662",
    strokeDasharray: "5 2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M85.4 26H95.6C95.9183 26 96.2235 25.8736 96.4485 25.6485C96.6736 25.4235 96.8 25.1183 96.8 24.8V15.2C96.8 14.8817 96.6736 14.5765 96.4485 14.3515C96.2235 14.1264 95.9183 14 95.6 14H85.4C85.0817 14 84.7765 14.1264 84.5515 14.3515C84.3264 14.5765 84.2 14.8817 84.2 15.2V17.636L80.948 15.314C80.8584 15.2502 80.7531 15.2123 80.6435 15.2043C80.5338 15.1964 80.4241 15.2187 80.3263 15.2688C80.2284 15.319 80.1463 15.3951 80.0887 15.4887C80.0312 15.5824 80.0005 15.6901 80 15.8V24.2C80.0005 24.3099 80.0312 24.4176 80.0887 24.5113C80.1463 24.6049 80.2284 24.681 80.3263 24.7312C80.4241 24.7813 80.5338 24.8036 80.6435 24.7957C80.7531 24.7877 80.8584 24.7498 80.948 24.686L84.2 22.364V24.8C84.2 25.1183 84.3264 25.4235 84.5515 25.6485C84.7765 25.8736 85.0817 26 85.4 26ZM95.6 15.2V24.8H85.4V21.2C85.3995 21.0901 85.3688 20.9824 85.3113 20.8887C85.2537 20.7951 85.1716 20.719 85.0737 20.6688C84.9759 20.6187 84.8662 20.5964 84.7565 20.6043C84.6469 20.6123 84.5416 20.6502 84.452 20.714L81.2 23.036V16.964L84.452 19.286C84.5416 19.3498 84.6469 19.3877 84.7565 19.3957C84.8662 19.4036 84.9759 19.3813 85.0737 19.3312C85.1716 19.281 85.2537 19.2049 85.3113 19.1113C85.3688 19.0176 85.3995 18.9099 85.4 18.8V15.2H95.6Z",
    fill: "#203662"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "translate(90 19)",
    fill: "#F3F6F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M96.923 21.8457V23.0765H94.1009L98.1538 27.1294L97.2837 27.9995L93.2307 23.9466V26.7688H92V21.8457H96.923Z",
    fill: "#203662"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragVideo);
export default __webpack_public_path__ + "static/media/Drag_Video.6e1f344f5acd2b2042647eaddf8d59a3.svg";
export { ForwardRef as ReactComponent };